import { render, staticRenderFns } from "./TheModalCategoriaSeguro.vue?vue&type=template&id=78a8be62&scoped=true&"
import script from "./TheModalCategoriaSeguro.vue?vue&type=script&lang=js&"
export * from "./TheModalCategoriaSeguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a8be62",
  null
  
)

export default component.exports